module.exports = __webpack_public_path__ + "img/cruise-speed.a3d7a299.svg";